module.exports = __webpack_public_path__ + "fonts/ralewayextrabold.34e74a2.woff";